export default "__VITE_ASSET__281d34ac__"